import DictionaryAliasIcon from '@mui/icons-material/MenuBook';
import DictionaryRedirect from './DictionaryRedirect';

export default {
  list: DictionaryRedirect,
  ICON: DictionaryAliasIcon
};